const KEY = "dv_selected_trip";

export const saveSelectedTrip = (trip, goal = {}) => {
  if (!trip) return null;
  const selected = {
    source: "controlled",
    id: trip.id,
    destination: trip.destination,
    region: trip.region || null,
    country: trip.country || null,
    origin: goal.departure || "Paris",
    nights: Number(goal.nights || 0) || null,
    date_mode: goal.date_mode || null,
    departure_date: goal.departure_date || null,
    return_date: goal.return_date || null,
    window_start: goal.window_start || null,
    window_end: goal.window_end || null,
    total: trip.total ?? null,
    decision: trip.decision || null,
    image: trip.image || null,
  };
  try { localStorage.setItem(KEY, JSON.stringify(selected)); } catch {}
  return selected;
};

export const loadSelectedTrip = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearSelectedTrip = () => {
  try { localStorage.removeItem(KEY); } catch {}
};


export const saveSelectedLiveTrip = (offer, goal = {}) => {
  if (!offer) return null;
  const flight = offer.flight_offer || {};
  const stay = offer.accommodation_offer || {};
  const selected = {
    source: offer.complete_trip_freshness || "live_partial",
    id: offer.id,
    destination: offer.destination_name || offer.destination,
    destination_code: offer.destination || null,
    region: stay.area || null,
    country: goal.country || null,
    origin: offer.origin || goal.departure || "Paris",
    nights: Number(offer.nights || stay.nights || goal.nights || 0) || null,
    date_mode: "fixed",
    departure_date: offer.departure_date || goal.departure_date || null,
    return_date: offer.return_date || goal.return_date || null,
    window_start: null,
    window_end: null,
    total: offer.trip_total ?? null,
    decision: offer.decision || null,
    budget_left: offer.budget_left ?? null,
    reasons: offer.decision_reasons || [],
    image: null,
    components: {
      flights: offer.flight_total ?? 0,
      hotel: offer.accommodation_total ?? 0,
      bags: offer.baggage_total ?? 0,
      transfers: offer.transfer_estimate ?? 0,
    },
    flight_offer: flight,
    accommodation_offer: stay,
    currency: offer.currency || "EUR",
    flight_source: offer.flight_source || null,
    accommodation_source: offer.accommodation_source || null,
    transfer_source: offer.transfer_source || "estimated",
    flight_fetched_at: offer.flight_fetched_at || null,
    hotel_fetched_at: offer.hotel_fetched_at || null,
  };
  try { localStorage.setItem(KEY, JSON.stringify(selected)); } catch {}
  return selected;
};


const LIVE_WATCH_KEY = "dv_live_watch";

export const saveLiveWatch = (selected) => {
  if (!selected) return;
  try { localStorage.setItem(LIVE_WATCH_KEY, JSON.stringify(selected)); } catch {}
};

export const loadLiveWatch = () => {
  try {
    const raw = localStorage.getItem(LIVE_WATCH_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearLiveWatch = () => {
  try { localStorage.removeItem(LIVE_WATCH_KEY); } catch {}
};
